<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel120">Change Password</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <Form class="form form-horizontal">
              <div class="row">
                <div class="col-12">
                  <div class="form-group row">
                    <div class="col-12 ">
                      <label>Current Password</label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12">
                      <div class="input-group">
                        <input
                            type="password"
                            v-model="currentPassword"
                            class="form-control"
                            :class="
                                  errorBag.has('currentPassword') ? 'is-invalid' : ''
                                "
                            name="currentPassword"
                            v-validate="'required'"
                        />
                        <small
                            v-show="errorBag.has('currentPassword')"
                            class="invalid-feedback"
                        >{{ "*" + errorBag.first("currentPassword") }}</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12 ">
                      <label>New Password</label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12">
                      <div class="input-group">
                        <input
                            type="password"
                            v-model="newPassword"
                            ref="newPassword"
                            class="form-control"
                            :class="
                                  errorBag.has('newPassword') ? 'is-invalid' : ''
                                "
                            name="newPassword"
                            v-validate="'required'"
                        />
                        <small
                            v-show="errorBag.has('newPassword')"
                            class="invalid-feedback"
                        >{{ "*" + errorBag.first("newPassword") }}</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12 ">
                      <label>Confirm Password</label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12">
                      <div class="input-group">
                        <input
                            type="password"
                            v-model="confirmPassword"
                            class="form-control"
                            :class="
                                  errorBag.has('confirmPassword') ? 'is-invalid' : ''
                                "
                            name="confirmPassword"
                            v-validate="'required|confirmed:newPassword'"
                        />
                        <small
                            v-show="errorBag.has('confirmPassword')"
                            class="invalid-feedback"
                        >{{ "*" + errorBag.first("confirmPassword") }}</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="form-group row d-flex justify-content-end">
                    <button
                        type="button"
                        class="btn btn-primary mr-1 d-flex"
                        @click="sendCall"
                        :disabled="loader"
                    >
                      <Loader :loading="loader" :size="size"></Loader>
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>

export default {
  props: ['show'],
  data() {
    return {
      list: [],
      loader: false,
      currentPassword:'',
      newPassword:'',
      confirmPassword:'',
      size: "10px",
    }
  },
  mounted() {
  },
  methods: {
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if(valid){
          this.loader = true
          let data = {
            currentPassword:this.currentPassword,
            newPassword:this.newPassword,
            confirmPassword:this.confirmPassword,
          }
          this.makeRequest('post', 'v1/change-password', data).then(callResponse => {

            this.loader = false
            if (!callResponse.error) {
              let code = callResponse.response.data.code;

              if (code == 200) {
                this.$emit('hide')
              }

            }


          });
        }
      })


    },
  },
  watch:{
    show(val){
      if(val){
        this.amount = this.refundInitialAmount
        this.isPartial = false
        this.description = ''
      }

    },
    isPartial(val){
      if(!val){
        this.amount = this.refundInitialAmount
      }
    }
  }
}
</script>

<style scoped>

/*--thank you pop starts here--*/
.thank-you-pop {
  width: 100%;
  padding: 20px;
  text-align: center;
}

.thank-you-pop img {
  width: 76px;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-bottom: 25px;
}

.thank-you-pop h1 {
  font-size: 42px;
  margin-bottom: 25px;
  color: #5C5C5C;
}

.thank-you-pop p {
  font-size: 20px;
  margin-bottom: 27px;
  color: #5C5C5C;
}

.thank-you-pop h3.cupon-pop {
  font-size: 25px;
  margin-bottom: 40px;
  color: #222;
  display: inline-block;
  text-align: center;
  padding: 10px 20px;
  border: 2px dashed #222;
  clear: both;
  font-weight: normal;
}

.thank-you-pop h3.cupon-pop span {
  color: #03A9F4;
}

.thank-you-pop a {
  display: inline-block;
  margin: 0 auto;
  padding: 9px 20px;
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
  background-color: #8BC34A;
  border-radius: 17px;
}

.thank-you-pop a i {
  margin-right: 5px;
  color: #fff;
}

#ignismyModal .modal-header {
  border: 0px;
}

/*--thank you pop ends here--*/

</style>

